export default __webpack_public_path__ + "assets/rotation-rally.mp4";